/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useRef, useState, useEffect } from 'react'
import { DFPAPIEndpoint,APIEndpoint, DFPAPIEndpointGalley } from '../../../utils/axios'
import { monthNames } from '../../../utils/commonFunctions';
import '../../../assets/styles/styles.scss'
import './menu.scss'
import editIcon from "../../../assets/edit.svg";
import deleteIcon from '../../../assets/delete.svg'
import View from '../../../assets/view.svg'
import '../../../assets/styles/inner/table.scss'
import moment from "moment";
import Select from 'react-select'
import {NGODatePicker} from '../../../common';
import MenuCalendar from './renderers/MenuCalendar';
import { menuSettingPal,sectorTypesList,customSelSearch } from '../../../utils/configs'
import {
  EditModal,
  DeleteConf
} from '../../../common'
import { PlansStatusSelectList } from '../../../utils/configs'
import { useTranslation } from 'react-i18next'
import { AddMenuPlanner } from './addMenuPlanner'
import usePermissions from '../../../utils/userPermissions';
 

const fetchAllPages = async (api, url, payload, pageSize = 100) => {
 
  const first = await api.post(url, { ...payload, page: 1, limit: 1 });
  const total = first?.count || 0;
  if (!total) return { ...first, items: first?.items || [] };
 
  const totalPages = Math.ceil(total / pageSize);
  const pages = await Promise.all(
    Array.from({ length: totalPages }, (_, i) =>
      api.post(url, { ...payload, page: i + 1, limit: pageSize })
    )
  );
  return { ...first, count: total, items: pages.flatMap(r => r?.items || []) };
};

export const MenuPlanner = props => {
  const { t,ready } = useTranslation()
  const modelStyle = { maxWidth: '80%' };
  const [searchKey, setSearchKey] = useState('')
  const [state, setState] = useState({sectors:[],aircrafts:[],sectorTypes:sectorTypesList,isOpenMenu:false,mealMenu:[], sectSel:[{key: 0, label:`Select sector`,label2:'Select sector', value: ''}],resetDataSource: false })
  const [data,setData]=useState({})
  const [, setActionItems] = useState([])
  const [modalTitle,setModalTitle]=useState('');
  const [editFormFields,setEditFormFields]=useState([])
  const [modalCustomButtons,setModalCustomButtons]=useState([])
  const [modalFormStatusObj, setModalFormStatusObj] = useState({ text: '' });
  const [perPageLimit, setPerPageLimit] = useState(50);
  const [plansStatusSelected, setPlansStatusSelected] = useState('');
  const didMountRef = useRef(false);
  const sType = localStorage.getItem('sType');

  const { hasPermission: createMenuPlanner } = usePermissions('create', "configuration.fsc.menu-planner");
const { hasPermission: editMenuPlanner } = usePermissions('edit', "configuration.fsc.menu-planner");
const { hasPermission: deleteMenuPlanner } = usePermissions('delete', "configuration.fsc.menu-planner");
const { hasPermission: viewDetailsMenuPlanner } = usePermissions('view', "configuration.fsc.menu-planner");

  useEffect(() => {
    setActionItems([
      {
        title: 'Actions',
        attribute: 'view',
        minWidth:100,
        width:120
      },
      {
        title: '',
        attribute: 'edit',
        minWidth:100,
        width:120
      },
      {
        title: '',
        attribute: 'delete',
        minWidth:100,
        width:120
      },

    ])
    let months = monthNames.reduce(
      (acc, item,index) =>[
      ...acc,
      { key: index + 1, label: item, value: index },

      ],
      []
      );
      setState((prev)=>{return {...prev,months}});
      let options=[]

    for(let i=2015;i<=moment().year()+10;i++){
      options.push( { key: i+1, label: i, value: i })
    }

    if(options.length){
      setState((prev)=>{return {...prev,year:options}})
    }
    getCurrentTimeLine();
    fetchWarehouse();
    fetchCaterers();
    fetchConfig();
    getSectors(null,null);
    fetchAirtcraftsType(null);
    fetChMealmenuConfig();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }
    if (plansStatusSelected || (state.sectSel.length > 0 && state.sectSel[0].value) || state.fromDate || state.toDate || (!state.fromDate && !state.toDate)) {
      fetchConfig();
    }
  }, [plansStatusSelected, state.sectSel, state?.fromDate, state?.toDate]);



const getCurrentTimeLine=()=>{
  const curDate = new Date();
const curYear = curDate.getFullYear();
const curMonth = monthNames[curDate.getMonth()];

if(curYear&&curMonth){
  setState((prev) => ({
    ...prev,
    monthSel:[{
      key: curDate.getMonth()+1,
      label: curMonth.toString(),
      value: curDate.getMonth()
  }],
  yearSel:[{
    key: curYear+1,
    label: curYear,
    value: curYear
}],
  }));
}
}
  const filterData = {
    action: 4,
    collection: '',
    filterOperation: 'or',
    fliters: [],
    limit: 5000,
    page: 1,
    searchParam: ''
  };

const  getSectors=async(src=null,dst=null)=>{
  try{
const res=await  DFPAPIEndpoint.get('stores');
if(res.success){
  setData(prevState => ({
    ...prevState,
    sectors:res.result}))
  const options = [{key: 0, label:`Select sector`,label2:'Select sector', value: '', destination: ''}];
  res.result.filter( (fieldValue, index) => {
    options.push({key: index+1, label:`${fieldValue.value}`,label2:fieldValue.originName, value: fieldValue.origin, destination: fieldValue.destination});
    return fieldValue;
  })
  setState(prevState => ({
        ...prevState,
        sectors:options}))
 
}
if(res.success&&!src&&!dst){
  setData(prevState => ({
    ...prevState,
    sectors:res.result}))
}
  }
  catch(err){

  }
  }
  const fetChMealmenuConfig = async () => {
    try {
      const [res, resItemMaster, resMealMaster] = await Promise.all([
        DFPAPIEndpointGalley.get('galley/mealMenuPlan/configs').catch(() => ({ data: null })),
        fetchAllPages(DFPAPIEndpoint, 'master/process', filterData).catch(() => ({ items: [] })),
        fetchAllPages(DFPAPIEndpoint, 'mealMaster/process', filterData).catch(() => ({ items: [] })),
      ]);

      if (res && res.data && (resItemMaster?.items || resMealMaster?.items)) {
        const items = resItemMaster?.items || [];
        const mealMasterItems = resMealMaster?.items || [];
        const newListMeals = (res.data?.mealTypes?.list || []).slice();
        const newObject = { id: 'beverages', label: 'Beverages', brands: [] };
        newListMeals.push(newObject);

        const modResponses = newListMeals.map(mlt => {
          switch (mlt.id) {
            case 'appetizer':
            case 'main':
            case 'dessert':
            case 'beverages':
              let optionsList = [];
              if (mealMasterItems && mealMasterItems.length > 0) {
                const categoryFiltered = mealMasterItems.filter((fl) => {
                  if (fl.deleted || fl.status === 'inactive') return false;
                  if (!fl.mealType) return true;
                  const flCategory = String(fl.mealType).toLowerCase().replace(/[^a-z0-9]/g, '');
                  const targetCategory = String(mlt.id).toLowerCase().replace(/[^a-z0-9]/g, '');
                  return flCategory === targetCategory || flCategory.includes(targetCategory) || targetCategory.includes(flCategory);
                });
                const itemsToMap = categoryFiltered.length > 0 ? categoryFiltered : mealMasterItems.filter(fl => !fl.deleted && fl.status !== 'inactive');
                optionsList = itemsToMap.map((fl) => ({ value: fl.mealName, id: fl.id || fl._id }));
              }
              // Fallback to item master if meal master is empty / not deployed yet
              if (optionsList.length === 0 && items && items.length > 0) {
                optionsList = items.map((fl) => ({
                  value: fl.itemName || fl.name || fl.label,
                  id: fl.itemId || fl.id || fl.code
                }));
              }
              mlt.brands = optionsList;
              break;
            default:
              break;
          }
          return mlt;
        });

        const options = [];
        res.data.classCodes?.list?.forEach((fieldValue) => {
          options.push({ key: fieldValue.systemCode, label: fieldValue.label, value: fieldValue.systemCode });
        });

        const optionsMt = [];
        res.data.mealCategory?.list?.forEach((fieldValue, index) => {
          optionsMt.push({ key: index + 1, label: fieldValue.label, value: fieldValue.id });
        });

        const optionsSct = [];
        sectorTypesList.forEach((fieldValue, index) => {
          optionsSct.push({ key: index + 1, label: fieldValue.label, value: fieldValue.value });
        });

        const renamedData = {
          menuSettings: modResponses?.map(item => renameKeys(item, keyMap)).map(data => {
            return {
              mealTypeId: data.mealTypeId,
              mealType: data.mealType,
              items: (data.mealTypeId === 'appetizer' || data.mealTypeId === 'dessert' || data.mealTypeId === 'main' || data.mealTypeId === 'beverages')
                ? data.items.map(item => ({ itemName: item.value, itemId: item.id }))
                : data.items.map(item => ({ itemName: item.label, itemId: item.value }))
            };
          })
        };

        if (renamedData.menuSettings) {
          const { menuSettings } = renamedData;
          const mealTypeMapping = {
            "continentalBreakfast": ["appetizer", "main", "dessert", "beverages"],
            "breakfast": ["appetizer", "main", "dessert"],
            "morningSnack": ["main", "dessert"],
            "lunch": ["appetizer", "main", "dessert"],
            "eveningSnack": ["main", "dessert"],
            "dinner": ["appetizer", "main", "dessert"],
            "supper": ["main", "dessert"],
            "alcoholicBeverages": ["whisky", "brandy", "vodka", "cognac", "whiteRum", "darkRum", "beer", "redWine", "whiteWine", "sparklingWine", "fortifiedWine", "liqueurs"],
            "nonAlcoholic": ["freshJuice", "cannedJuice", "cannedSmoothies", "energyDrinks", "softDrinks", "infusedWater", "sparklingWater", "water"],
          };

          menuSettingPal.forEach(category => {
            category.mealsSelection = [];
            const mealTypeIdsToAdd = mealTypeMapping[category.mealCategoryId];
            if (mealTypeIdsToAdd) {
              mealTypeIdsToAdd.forEach(mealTypeId => {
                const mealTypeObject = menuSettings.find(type => type.mealTypeId === mealTypeId);
                if (mealTypeObject) {
                  category.mealsSelection.push(mealTypeObject);
                }
              });
            }
          });
        }

        setState(prevState => ({
          ...prevState,
          mealMenuClass: options,
          mealMenuCatergory: res.data.mealCategory,
          menuSettings: menuSettingPal,
          mealTypesGroup: optionsMt,
          sectorTypes: optionsSct,
        }));
      }
    } catch (err) {
      console.error("Error in fetChMealmenuConfig:", err);
    }
  }
  const fetchAirtcraftsType = async (airId=null) => {
    const basePayload = {
      action: 4,
      collection: "",
      filterOperation: "or",
      filters: [],
      limit: 10,
      page: 1,
      searchParam: ""
    };
    try {
 
      const countRes = await DFPAPIEndpointGalley.post('galley/aircraftTypes/process', { ...basePayload, limit: 1 });
      const total = countRes?.count || 0;
      const totalPages = Math.ceil(total / basePayload.limit);
 
      const pageResults = await Promise.all(
        Array.from({ length: totalPages }, (_, i) =>
          DFPAPIEndpointGalley.post('galley/aircraftTypes/process', { ...basePayload, page: i + 1 })
        )
      );

      const res = {
        success: countRes?.success,
        count: total,
        items: pageResults.flatMap(r => r?.items || [])
      };

          if(res.success && res.items){
 
            const aircraftList = res.items.map(act => ({ ...act, value: act.key }));
 
            const isAllowed = act => act.aircraftFor && (act.aircraftFor === 'pal' || act.aircraftFor === process.env.REACT_APP_ACCOUNT_DOMAIN);
            const allowedList = aircraftList.filter(isAllowed);

            setData(prevState => ({
              ...prevState,
              aircraft: allowedList
              })
            );

            const options = allowedList.map((fieldValue, index) => ({key: index+1, label: fieldValue.value, value: fieldValue.id}));

          setState(prevState => ({
            ...prevState,
            aircrafts: options
          }));

          if(airId){
            return allowedList.find(aId=>aId.id===airId)?.value;
          }
        }
    } catch (error) {

    }

  }

const fetchCaterers = async (page, perPage,catId=null,catStn=null) => {
if(catId&&catStn){
filterData.page = page;
filterData.limit =  perPage;
filterData.searchParam = null;
filterData.filters=[{warehouseId: parseInt(catStn)}];
try{
    const res = await DFPAPIEndpoint.post('vendorMappings', JSON.stringify(filterData));
    if(res.count &&!catId){
    setData(prevState => ({
    ...prevState,
    caterers:res.items}))
    const options=[]
    res.items.map( (fieldValue, index) => {
    options.push({key: index+1, label: `${fieldValue.name} ${fieldValue.name2}`, value: fieldValue.code});
    return fieldValue;
    })
    setState(prevState => ({
    ...prevState,
    caterers:options
    }));
    }

    // if(catStn&&catId&&res.count){
    //   const catObj=res.items.find(cat=>cat.vendorId===catId);
    //   if(Object.keys(catObj).length){
    //     return `${catObj.vendorName} ${catObj.vendorCode}`
    //   }
    // }
 }
 catch(err){
 }
  }
}
const fetchWarehouse = async() => {
  try {
     const resp = await fetchAllPages(APIEndpoint, 'warehouses/process', filterData);
     if(resp.success){
      setData(prevState => ({
        ...prevState,
        warehouse:resp.items}));

      const options=[]
      resp.items.filter( (fieldValue, index) => {
        const warehouseId = Number(fieldValue.itemId);
        options.push({key: warehouseId, id: warehouseId, label: fieldValue.warehouseName, value: fieldValue.cluster?.clusterName});
        return fieldValue;
      })
      setState(prevState => ({
      ...prevState,
      warehouses:options
    }));
  }
     }
      catch (err) {

      }
}


  const preCompile = {
    save: t('buttons.save'),
    uploadLayout: t('pages.pagesContent.aircrafts.uploadLayout')
  }

  function renameKeys(obj, keyMap) {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [keyMap[key] || key, value])
    );
  }

  const keyMap = {
    "id": "mealTypeId",
    "label": "mealType",
    "brands": "items",
  };

  const handleFormSubmit = async (e, updated) => {
    if (updated) {
      const body = {
        model: updated.model,
        variant: updated.variant,
        capacity: parseInt(updated.capacity)
      }
      try {
        const resp = await DFPAPIEndpoint.post(`aircraftTypes`, body)
        if (resp.success) {
          setModalFormStatusObj({ text: resp.message })
        }
      } catch (resp) {
        setModalFormStatusObj({ text: resp.message })
      }
    }
  }

  const onClose = () => {
    setState(_prev => {
      return { ..._prev, selected: false,resetDataSource: !state.resetDataSource }
    })
    setModalFormStatusObj({ text: '' })
    fetchConfig();
  }

  const onAddItemHandler = () => {
    setState(_prev => {
      return {
        ..._prev,
        selected: { action: 'createMenuPlan' },
        resetDataSource: !state.resetDataSource
      }
    })
  }
  const onPerLimitChange = e => {
    setPerPageLimit(Number(e.target.value))
  }

  const onPlanStatusChange = e => {
    setPlansStatusSelected(e.target.value);
  };

  const getReactSelectStyles = (width) => {
    const baseCustom = typeof customSelSearch === 'function' ? customSelSearch() : (customSelSearch || {});
    return {
      ...baseCustom,
      control: (base) => ({
        ...base,
        width: width,
        height: '2.37rem',
        minHeight: '2.37rem',
        backgroundColor: '#1c2b40',
        border: '0.7px solid #ffffff',
        borderRadius: '4px',
        boxShadow: 'none',
        cursor: 'pointer',
      }),
      valueContainer: (base) => ({
        ...base,
        height: '2.37rem',
        padding: '0 8px',
        display: 'flex',
        alignItems: 'center',
      }),
      input: (base) => ({
        ...base,
        margin: 0,
        padding: 0,
        color: '#ffffff',
      }),
      singleValue: (base) => ({
        ...base,
        color: '#ffffff',
        fontSize: '13px',
        fontWeight: '500',
        margin: 0,
      }),
      indicatorsContainer: (base) => ({
        ...base,
        height: '2.37rem',
      }),
      dropdownIndicator: (base) => ({
        ...base,
        padding: '4px 6px',
        color: '#ffffff',
        '&:hover': {
          color: '#ffffff',
        },
      }),
      menu: (base) => ({
        ...base,
        backgroundColor: '#1c2b40',
        border: '0.7px solid #ffffff',
        zIndex: 9999,
      }),
      option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected ? '#2a3f5f' : state.isFocused ? '#24344d' : '#1c2b40',
        color: '#ffffff',
        fontSize: '13px',
        cursor: 'pointer',
      }),
    };
  };

  const handleDateChange = (newDate, action) => {
    const validDate = (newDate && newDate instanceof Date && !isNaN(newDate.getTime())) ? newDate : new Date();
    const yearVal = validDate.getFullYear();
    const monthIndex = validDate.getMonth();
    const monthLabel = monthNames[monthIndex];

    const monthOpt = { key: monthIndex + 1, label: monthLabel, value: monthIndex };
    const yearOpt = { key: yearVal + 1, label: yearVal, value: yearVal };

    setState((prev) => ({
      ...prev,
      monthSel: [monthOpt],
      yearSel: [yearOpt],
      defaultDate: validDate,
      resetDataSource: !prev.resetDataSource,
      ...(action === 'TODAY' ? { fromDate: null, toDate: null } : {})
    }));
  };

  const handleYear = (e) => {
    setState(_prev => {
      const yearVal = e.value;
      const monthVal = _prev.monthSel?.[0]?.value ?? 0;
      return {
        ..._prev,
        yearSel: [e],
        defaultDate: new Date(yearVal, monthVal, 1, 0, 0, 0)
      };
    });
  }

  const handleMonth = (e) => {
    setState(_prev => {
      const monthVal = e.value;
      const yearVal = _prev.yearSel?.[0]?.value ?? new Date().getFullYear();
      return {
        ..._prev,
        monthSel: [e],
        defaultDate: new Date(yearVal, monthVal, 1, 0, 0, 0)
      };
    });
  }
  const handleSectors = (e) => {
    setState(_prev => {
      return {
        ..._prev,
        sectSel: [e],
      };
    });
  }
  const onCloseDelete = () => {
    setState(_prev => {
      return { ..._prev,resetDataSource: !state.resetDataSource, delete: false }
    })
    setModalFormStatusObj({ text: '' })
    fetchConfig();
  }

  const onContinue = async () => {
    setState(_prev => {
      return { ..._prev, deleteProg: true }
    })
    try {
      const res = await DFPAPIEndpointGalley.delete(
        `galley/mealMenuPlan/${state.selected._id}`
      )
      if (res.success) {
        setState(_prev => {
          return { ..._prev, deleteProg: false,resetDataSource: !state.resetDataSource }
        })
        setModalFormStatusObj({ text: res.message })
        fetchConfig();
      }
    } catch (err) {
      const errorMsg=JSON.parse(err?.message);
      setModalFormStatusObj({ error: errorMsg.data?.message||"Something went wrong!" })
    }
    let timerId = setTimeout(() => {
      clearTimeout(timerId)
      setModalFormStatusObj({ text: ''})
      setState((_) => ({ ..._, delete: false,selected:false }))
    }, 1500)
  }

  var myHeaders = new Headers()
  myHeaders.append('Content-Type', 'application/json')
  myHeaders.append('user_id', localStorage.getItem('user_id'))
  myHeaders.append('x-csrf-token', localStorage.getItem('token'))
  myHeaders.append('X-Bearer-Token', localStorage.getItem('bearer_token'))


  function actionsMenuPlanner(props){
    return (
      props.data?
      <>
        <div className='icon-aircraft-container'>
        <img className='aircraft-actions' alt='view' onClick={(e) => setSector(props.data, 'viewMenuPlan')} src={View}/>
        <span className="tooltip-action">View</span>
        </div>
        <div className='icon-aircraft-container'>
        <img className='aircraft-actions' alt='edit' onClick={(e) => setSector(props.data, 'editMenuPlan')} src={editIcon}/>
        <span className="tooltip-action">Edit</span>
        </div>
        <div className='icon-aircraft-container'>
        <img  style={{width:'25.5px',height:'25.5px'}} className='aircraft-actions' alt='delete' onClick={(e) => setSector(props.data, 'deleteMenuPlan')} src={deleteIcon}/>
        <span className="tooltip-action">Delete</span>
        </div>
      </> : <></>
    );
  }


  const setSector = (data,type) => {
    if(type==='viewMenuPlan'){
      let updatedEditFields=[]
      setModalTitle(`Menu - ${data?.status === 'expired' ? `${data?.menuPlanName} (Expired)` : data?.menuPlanName}`);
      updatedEditFields = [{ label: 'View Menu Planner', type: 'viewMenuPlanner', attribute: 'items'}];
      updatedEditFields = updatedEditFields.filter( row => {
          if (row.type === 'viewMenuPlanner') {
            row.value = row;

          }
          return row;
      });


      setModalCustomButtons([
        { label: 'Close', attribute: 'button', type: 'button', disabled: false, className: 'close-button', action: (e) => {

                onClose();
                return false;
            }
        }
      ]);

      setEditFormFields( [ ...updatedEditFields ] );

      const whDetails = data?.cateringStationDetails || {
        warehouseName: data?.cateringStationName || (state.warehouses?.find(w => String(w.id || w.key) === String(data?.cateringStation))?.label) || data?.cateringStation || '',
        warehouseCode: data?.cateringStationCode || ''
      };
      const catDetails = data?.catererDetails || {
        vendorName: data?.catererName || (state.caterers?.find(c => String(c.value || c.code) === String(data?.caterer))?.label) || data?.caterer || '',
        vendorCode: data?.catererCode || ''
      };

      setState((_prev) => {
        return { ..._prev, selected: { ...data, cateringStationDetails: whDetails, catererDetails: catDetails, action: type} };
      });

    }
    else if(type==='editMenuPlan' && editMenuPlanner){
      setState(_ => {
        return {
          ..._,
          resetDataSource: !state.resetDataSource,
          selected: {...data,action:'editMenuPlan'},
          view: true,
          deleteProg: false
        }
      })
    }
   else if(type==='deleteMenuPlan' && deleteMenuPlanner){
    setState(_prev => {
      return { ..._prev, delete: true, resetDataSource: !state.resetDataSource,
        selected: data,
        view: true,
        deleteProg: false }
    })
   }
   else{
    setState( (_prev) => {
      return { ..._prev, selected: {...data ,action: type},resetDataSource:!state.resetDataSource}
    });
   }
  };

 

  const fetchConfig = async () => {
    try {
      let payload = {
        searchParam: "", action: 4,
        filters: []
      };
      if (plansStatusSelected) {
        payload.status = plansStatusSelected;
      }
      if (searchKey) {
        payload.searchKey = searchKey;
      }

      try {
        const resp = await fetchAllPages(DFPAPIEndpointGalley, 'galley/mealMenuPlan/list', payload);
        if (resp.success && Array.isArray(resp.items)) {
          let items = resp.items;
 
          if (plansStatusSelected) {
            items = items.filter(fl => String(fl.status).toLowerCase() === String(plansStatusSelected).toLowerCase());
          }
 
          const selSector = state.sectSel?.[0];
          if (selSector && selSector.value && selSector.value !== '') {
            items = items.filter(fl =>
              fl.sourceStation === selSector.value ||
              fl.sectorDetails?.value === selSector.label ||
              fl.sectorDetails?.origin === selSector.value
            );
          }
 
          if (state.fromDate || state.toDate) {
            items = items.filter(fl => {
              if (!fl.fromDate || !fl.toDate) return false;
              const flStart = moment(fl.fromDate).startOf('day');
              const flEnd = moment(fl.toDate).endOf('day');
              const filterFrom = state.fromDate ? moment(state.fromDate).startOf('day') : null;
              const filterTo = state.toDate ? moment(state.toDate).endOf('day') : null;

              if (filterFrom && filterTo) {
                return flStart.isSameOrBefore(filterTo) && flEnd.isSameOrAfter(filterFrom);
              } else if (filterFrom) {
                return flEnd.isSameOrAfter(filterFrom);
              } else if (filterTo) {
                return flStart.isSameOrBefore(filterTo);
              }
              return true;
            });
          }

          // Determine target date for calendar
          let targetDate = state.defaultDate || new Date();
          if (state.fromDate) {
            targetDate = new Date(state.fromDate);
          }

          setState(prevState => ({
            ...prevState,
            mealMenu: items,
            defaultDate: targetDate,
            resetDataSource: !prevState.resetDataSource
          }));
        }
      } catch (error) {
        console.error("Error fetching menu plan list:", error);
      }
    } catch (err) {
      console.error("Error in fetchConfig:", err);
    }
  }


  const delProps = {
    onContinue,
    onCloseDelete,
  }
  const handleMenuOpen=(isOPen)=>{
    setState(prevState => ({
      ...prevState,
      isOpenMenu: isOPen,
    }));
  }

  let onChangeInputFromDate = e => {
    setState((_)=>{return {..._,fromDate:e.target.value}})
  }

  let onChangeInputToDate = e => {
    setState((_)=>{return {..._,toDate:e.target.value}})
  }

  const onSearch = e => {
    setSearchKey(e.target.value)
  }
  return (
    <div className='op-aircraft-container flexCol full-flex ag-theme-alpine-dark'>
      {
        <>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%', padding: '10px 15px 15px 15px' }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0 }}>
              <label style={{ color: '#ffffff', fontSize: '13px', fontWeight: '500', lineHeight: '16px', height: '16px', marginBottom: '6px', marginTop: 0, display: 'block' }}>Status</label>
              <div className="status-button" title="Select filter by status" style={{ border: '0.7px solid #ffffff', borderRadius: '4px', height: '2.37rem', minHeight: '2.37rem', display: 'flex', alignItems: 'center', background: '#1c2b40', margin: 0, marginTop: 0 }}>
                <select
                  className="offBlueBg"
                  onChange={onPlanStatusChange}
                  value={plansStatusSelected}
                  id="status-select-list"
                  style={{ height: '100%', background: 'transparent', color: '#ffffff', border: 'none', outline: 'none', padding: '0 8px', borderRadius: '4px', fontSize: '13px', fontWeight: '500', cursor: 'pointer' }}
                >
                  {PlansStatusSelectList.map((_) => (
                    <option key={_.value} value={_.value} style={{ background: '#1c2b40', color: '#ffffff' }}>
                      {_.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {state && state.sectSel ? (
              <div style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0 }}>
                <label style={{ color: '#ffffff', fontSize: '13px', fontWeight: '500', lineHeight: '16px', height: '16px', marginBottom: '6px', marginTop: 0, display: 'block' }}>Sector</label>
                <Select
                  options={state?.sectors}
                  defaultValue={state?.sectSel[0]?.label ? state?.sectSel[0]?.label : ''}
                  value={state?.sectors.filter(function (option) {
                    return (
                      state?.sectSel.length &&
                      state?.sectSel.find((sc) => sc.label === option.label)
                    );
                  })}
                  onChange={handleSectors}
                  onMenuOpen={() => handleMenuOpen(true)}
                  onMenuClose={() => handleMenuOpen(false)}
                  styles={getReactSelectStyles('170px')}
                  placeholder="Select Sector"
                  isSearchable={true}
                  isMulti={false}
                />
              </div>
            ) : null}

            <div style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0 }}>
              <label style={{ color: '#ffffff', fontSize: '13px', fontWeight: '500', lineHeight: '16px', height: '16px', marginBottom: '6px', marginTop: 0, display: 'block' }}>From Date</label>
              <NGODatePicker
                value={state.fromDate}
                selectsStart={true}
                style={{ border: '0.7px solid #ffffff', borderRadius: '4px', height: '2.37rem', width: '9rem', margin: 0 }}
                dateFormat="dd/MM/yyyy"
                name="fromDate"
                placeholder={'Select From Date'}
                isOpen={state.isOpenMenu}
                isClearable={true}
                onCalendarOpen={() => handleMenuOpen(true)}
                onCalendarClose={() => handleMenuOpen(false)}
                onChange={onChangeInputFromDate}
              />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0 }}>
              <label style={{ color: '#ffffff', fontSize: '13px', fontWeight: '500', lineHeight: '16px', height: '16px', marginBottom: '6px', marginTop: 0, display: 'block' }}>To Date</label>
              <NGODatePicker
                value={state.toDate}
                selectsEnd={true}
                style={{ border: '0.7px solid #ffffff', borderRadius: '4px', height: '2.37rem', width: '9rem', margin: 0 }}
                placeholder={'Select To Date'}
                dateFormat="dd/MM/yyyy"
                name="toDate"
                isOpen={state.isOpenMenu}
                isClearable={true}
                onCalendarOpen={() => handleMenuOpen(true)}
                onCalendarClose={() => handleMenuOpen(false)}
                onChange={onChangeInputToDate}
              />
            </div>

            {state && state.monthSel && state.monthSel.length > 0 ? (
              <div style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0 }}>
                <label style={{ color: '#ffffff', fontSize: '13px', fontWeight: '500', lineHeight: '16px', height: '16px', marginBottom: '6px', marginTop: 0, display: 'block' }}>Month</label>
                <Select
                  defaultValue={state?.monthSel[0]?.label ? state?.monthSel[0]?.label : ''}
                  options={state?.months}
                  placeholder="Search/Select Month"
                  value={state?.months.filter(function (option) {
                    return (
                      state?.monthSel.length &&
                      state?.monthSel.find((sc) => sc.label === option.label)
                    );
                  })}
                  onChange={handleMonth}
                  onMenuOpen={() => handleMenuOpen(true)}
                  onMenuClose={() => handleMenuOpen(false)}
                  styles={getReactSelectStyles('135px')}
                  isSearchable={true}
                  isMulti={false}
                />
              </div>
            ) : null}

            {state && state.yearSel && state.yearSel.length > 0 ? (
              <div style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0 }}>
                <label style={{ color: '#ffffff', fontSize: '13px', fontWeight: '500', lineHeight: '16px', height: '16px', marginBottom: '6px', marginTop: 0, display: 'block' }}>Year</label>
                <Select
                  defaultValue={state?.yearSel[0]?.label ? state?.yearSel[0]?.label : ''}
                  options={state?.year}
                  placeholder="Select Year"
                  value={state?.year.filter(function (option) {
                    return (
                      state?.yearSel.length &&
                      state?.yearSel.find((sc) => sc.label === option.label)
                    );
                  })}
                  styles={getReactSelectStyles('105px')}
                  onMenuOpen={() => handleMenuOpen(true)}
                  onMenuClose={() => handleMenuOpen(false)}
                  onChange={handleYear}
                  isSearchable={true}
                  isMulti={false}
                />
              </div>
            ) : null}
          </div>

          {createMenuPlanner ? (
            <div style={{ display: 'flex', alignItems: 'flex-start', paddingTop: '22px', margin: 0 }}>
              <button
                disabled={!Boolean(Object.keys(state).length > 6)}
                className="add-item-button"
                style={{ height: '2.37rem', padding: '0 18px', borderRadius: '4px', fontSize: '14px', fontWeight: '600', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', margin: 0 }}
                onClick={onAddItemHandler}
              >
                {t('buttons.addMenuplan')}
              </button>
            </div>
          ) : null}
        </div>


        {state &&(!state.selected?.action)?
        <MenuCalendar data={state} actions={setSector} onDateChange={handleDateChange}/>:<></>
        }
        </>
      }
       {
        state && Boolean(state.selected) &&
          ( state.selected?.action === 'viewMenuPlan' && viewDetailsMenuPlanner) ?
          (
            <EditModal
                className='salesPageModal'
                title={ modalTitle }
                columnViewType={true}
                customModalStyle={ modelStyle }
                onClose={onClose}
                // onSubmit={onSubmit}
                modalFormStatusObj={modalFormStatusObj}
                actionsMenuView={setSector}
                modalCustomButtons={modalCustomButtons}
                fields={ editFormFields.map( (elt) => {

                        if ( state.selected.action === 'viewMenuPlan' ) {
                            return {...elt, onSelectAction:setSector,initialValue: state.selected ?? '' }
                        }
                        else {
                            return {...elt, initialValue: '' }
                        }
                  })
                }
                showFieldsInColumn={true}
            />
        )
        : null
      }
      {state&&state?.delete && <DeleteConf   {...delProps} modalFormStatusObj={modalFormStatusObj} description={`Are you sure you want to delete "${state?.selected?.menuPlanName}" meal Plan ?`} />}


      {state &&
        Boolean(state.selected) &&
        (state.selected?.action === 'createMenuPlan'|| state.selected?.action === 'editMenuPlan') && (
          <AddMenuPlanner
            key={state.selected?.action}
            options={state}
            setState={setState}
            data={data}
            title={state.selected.action==='createMenuPlan'?"Create Menu":`Edit Menu - ${state.selected.menuPlanName}`}
            buttonLabel={preCompile.save}
            onSubmit={handleFormSubmit}
            setModalFormStatusObj={setModalFormStatusObj}
            onClose={onClose}
          />
        )}
        {
        !ready &&<div className='overlay_hide sub'></div>
      }
    </div>
  )
}
